import { PlaceholderText } from 'components/Placeholders';
import useMetricSelect from 'utils/hooks/useMetricSelect';

function SelectableScoreCardMetric({
    metricsList,
    metrics,
    defaultMetric,
    isLoading,
    tikTokSourceAttributionProps,
}) {
    const { selected, formattedValue, selectMenu } = useMetricSelect({
        metricsList,
        metrics,
        defaultMetric,
        tikTokSourceAttributionProps,
    });
    return (
        <div>
            <dt>{selectMenu}</dt>
            <dd>
                {!metrics?.[selected?.key] && isLoading ? (
                    <PlaceholderText width="1em" />
                ) : (
                    formattedValue
                )}
            </dd>
        </div>
    );
}

export default SelectableScoreCardMetric;
